import { colors } from '../../colors';
var book = {
  fieldBorderColor: colors.onyx,
  errorColor: colors.warningRed
};
export default book;